import * as R from 'ramda';
import Work, {Id} from 'types/Work';
import {Artist} from 'types/Artist';
import * as CONSTANTS from '../constants';
const {
	FETCH_OPTS,
	WORKS_JSON_FILE,
	ARTISTS_JSON_FILE
} = CONSTANTS;

const PER_PAGE = 50;

const requestPage = p => getData(
	`/wp-json/wp/v2/works?per_page=${PER_PAGE}&page=${p}`,
	FETCH_OPTS
);

async function getData(url, opts){
	const data = await fetch(url, opts);
	return data.json();
}

export const FETCH_WORKS = 'FETCH_WORKS';
export const fetchWorks = () =>
	async (dispatch, getState) => {
		// Don't refresh on every route
		const currentWorks = getState().works.all;
		if (currentWorks.length > 0) {
			return currentWorks;
		}
		else {

			const response = await fetch('/wp-json/wp/v2/works?per_page=100&page=1');
			const totalPagesHeader = response.headers.get('X-WP-TotalPages');
			const totalWorks = response.headers.get('X-WP-Total');

			const totalPages = totalPagesHeader ? parseInt(totalPagesHeader, 10) : 0;
			const theRest = Array.from(
				{ length: totalPages - 1 },
				(_, i) => i + 2
			);

			const pages = [
				await response.json(),
				...await Promise.all(
					theRest.map(requestPage)
				)
			].flat();
			console.log(pages);

			console.log('Total works:', totalWorks, 'total pages:', totalPages);


			let works = await getData(
				WORKS_JSON_FILE,
				FETCH_OPTS
			);
			dispatch(receiveWorks(works));
			return works;
		}
	}

export type RECEIVE_WORKS = 'RECEIVE_WORKS';
export const RECEIVE_WORKS: RECEIVE_WORKS = 'RECEIVE_WORKS';
export interface ReceiveWorks{
	type: RECEIVE_WORKS,
	works: Work[]
}
export function receiveWorks(works): ReceiveWorks{
	return {type: RECEIVE_WORKS, works};
}


export const SET_WORK_DIMENSIONS = 'SET_WORK_DIMENSIONS';
export function setWorkDimensions(id: Id, dimensions){
	return {
		type: SET_WORK_DIMENSIONS,
		id,
		dimensions
	};
}


export const FETCH_ARTISTS = 'FETCH_ARTISTS';
export const fetchArtists = () =>
	async (dispatch, getState) => {
		// Don't refresh on every route
		const currentArtists = getState().artists;
		if (currentArtists.length > 0) {
			return currentArtists;
		}
		let artists = await getData(
			ARTISTS_JSON_FILE,
			FETCH_OPTS
		);
		dispatch(receiveArtists(artists));
		return artists;
	}



export type RECEIVE_ARTISTS = 'RECEIVE_ARTISTS';
export const RECEIVE_ARTISTS: RECEIVE_ARTISTS = 'RECEIVE_ARTISTS';
export interface ReceiveArtists {
	type: RECEIVE_ARTISTS;
	artists: Artist[];
}
export function receiveArtists(artists): ReceiveArtists{
	return {type: RECEIVE_ARTISTS, artists};
}